import DbAPISvcMod from './db-mock.svc.js';
import DbViewSvcMod from './db-view.svc.js';
import BundletTagHlpMod from './bundle-tag.hlp.js';
//
let compMod = angular.module('mod.svc.indexDbSvc', [DbAPISvcMod, DbViewSvcMod, BundletTagHlpMod]);
export default (compMod = compMod.name);
